<template>
  <div class="stats-crcl">
    <div class="st-circle-blk"  style="position: relative;">
      <div ref="circle">
        <span class="progress-bar-circle-percentes">
          {{remainingDays}}
          <i>
            <span class="cnt">Days Left</span>
          </i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    totalDays: {
      required: true,
      type: Number
    },
    remainingDays: {
      required: true,
      type: Number
    }
  },
  mounted() {
    console.log('aaaa', this.$refs.circle)
    let el = $(this.$refs.circle, this.remainingDays / this.totalDays)
    this.circleProgress = new CircleProgress({
      animation: false,
      value: this.remainingDays / this.totalDays,
      size: 170,
      fill: '#ffffff',
      thickness: '10',
      emptyFill: '#07313c',
      startAngle: -1.5708,
      reverse: true,
      el
    })
    console.log(this.circleProgress)
    this.circleProgress.animation = false
  },
  watch: {
    remainingDays(remainingDays) {
      let value = remainingDays / this.totalDays
      if (value < 0.01) value = 0.01
      this.circleProgress.setValue(value)
    }
  }
}
</script>

<style>
</style>